import React from "react";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import FAQ from "@/components/FAQ";
import WaitlistCTA from "@/components/WaitlistCTA";
import Footer from "@/components/Footer";
import ExitIntent from "@/components/ExitIntent";
import StickyBar from "@/components/StickyBar";

export default function Landing() {
  const scrollToWaitlist = () => {
    const el = document.getElementById("waitlist");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    setTimeout(() => {
      const input = document.querySelector(
        '[data-testid="waitlist-email-input"]'
      );
      input?.focus();
    }, 700);
  };

  return (
    <div className="relative min-h-screen bg-[#050505] text-white antialiased">
      <div className="ds-grain" aria-hidden />
      <Nav onCtaClick={scrollToWaitlist} />
      <main>
        <Hero onCtaClick={scrollToWaitlist} />
        <FAQ />
        <WaitlistCTA />
      </main>
      <Footer />
      <StickyBar />
      <ExitIntent />
    </div>
  );
}
